import React from 'react'
import './DelayedInput.css';
import '../Theme.css';
import {DebounceInput} from "react-debounce-input";

function DelayedInput({style, type, value, placeholder, onChange}) {

    const className = "DebounceInput " + style;

    return (
        <DebounceInput
            className={className}
            type={type}
            step=".01"
            value={value}
            placeholder={placeholder}
            debounceTimeout={300}
            onChange={onChange}/>
    )
}

export default DelayedInput;
